export const getRedirectQueryString = (): string => {
  const queryStrings = getQueryStrings()
  return queryStrings['redirect'] || ''
}

export const getRegistrationQueryString = (): string => {
  const queryStrings = getQueryStrings()
  return queryStrings['registrationToken'] || ''
}

export const getQueryStrings = (): { [key: string]: string } => {
  const searchParams = new URLSearchParams(window.location.search)
  const queryStrings: { [key: string]: string } = {}
  for (const [key, value] of searchParams.entries()) {
    queryStrings[key] = value
  }
  return queryStrings
}
